export const DOUBT_STATE = {
  asdPending: {
    imageURL: 'doubts20/findingMatch.svg',
    heading: 'Finding a solution',
    subText: 'We match your doubt with the best solutions available',
    animation: 'searchingForSolution'
  },
  asdFailed: {
    imageURL: 'doubts20/findingMatch.svg',
    heading: 'Finding a solution',
    subText: 'We match your doubt with the best solutions available',
    animation: 'searchingForSolution'
  },
  doubtSubmitted: {
    imageURL: 'doubts20/doubtSubmitted.svg',
    heading: 'Your doubt is submitted',
    subText:
      'An educator will look into your doubt and get back to you shortly',
    animation: 'doubtsSubmitted'
  },
  invalidDoubt: {
    imageURL: 'doubts20/dailyLimitReached.svg',
    heading: 'Invalid doubt',
    subText:
      'Your picture didn’t contain a valid question, upload a different picture',
    animation: 'invalidDoubt'
  },
  noSolutionAvailable: {
    imageURL: 'doubts20/noSolutionAvailable.svg',
    heading: 'No solution found',
    subText:
      'We couldn’t find a solution for your doubt. Try a better photo or a different question.',
    animation: 'noSolutionsAvailable'
  },
  findingSolution: {
    imageURL: 'doubts20/findingMatch.svg',
    heading: 'Finding a solution',
    subText: 'We match your doubt with the best solutions available',
    animation: 'searchingForSolution'
  }
};

export const DOUBT_SEGMENT_EVENT_SOURCE = 'Doubts and solution Content_pages';

export const PRE_SUBS_STATE = {
  instantMatchFailed: {
    heading: 'Want to get a new solution?'
  },
  negativeFeedback: {
    heading: 'Is your doubt not solved?'
  }
};

export const FEEDBACK_INTENT = {
  POSITIVE_FEEDBACK: 'POSITIVE',
  NEGATIVE_FEEDBACK: 'NEGATIVE'
};

export const ASK_AN_EDUCATOR = {
  askEducator: {
    heading: 'Need more help with your doubt?',
    text: 'Submit to an educator for review',
    image: 'doubts20/requestSubmitted.svg',
    initialCard: true
  },
  doubtSubmitted: {
    heading: 'Solution is in review',
    text: 'An educator is looking into this, and we’ll notify you when we have an update`',
    image: 'doubts20/requestSubmitted.svg',
    initialCard: false
  },
  doubtReviewed: {
    heading: 'Your feedback has been reviewed',
    text: 'We found no issue with the solution available. There are no further updates.',
    image: 'doubts20/stillUnclear.svg',
    initialCard: false
  }
};
export const DOUBT_CARD_STATE = {
  available: 'AVAILABLE',
  newSoluton: 'NEW SOLUTION'
};

export const subjectSelectionState = {
  regularFlow: 'Regular AAD flow',
  automaticSubjectSelectedFlow: 'Automatic Subject Selection',
  manualAfterAsdFailed: 'Manual Selection After ASD Fail',
  defaultSubjectSelection: 'Default Subject Selected',
  afterRecevingSolution: 'After Receiving Solution'
};

export const DOUBT_STATUS = {
  SOLUTION_PENDING: 'SOLUTION_PENDING',
  INSTANT_MATCH_IN_PROGRESS: 'INSTANT_SOLUTION_IN_PROGRESS',
  INVALID_DOUBT: 'INVALID_CONTENT',
  TIMEOUT: 'TIMEOUT',
  SOLUTION_AVAILABLE: 'SOLUTION_AVAILABLE',
  SOLVED: 'SOLVED',
  UNDER_EDUCATION_REVIEW: 'UNDER_EDUCATOR_REVIEW',
  NO_ISSUES_FOUND_WHILE_REVIEW: 'NO_ISSUES_FOUND_WHILE_REVIEW',
  ASD_AVAILABLE: 'COMPLETED',
  ASD_FAILED: 'FAILED',
  ASD_PENDING: 'INPROGRESS',
  ASD_NOT_SUPPORTED: 'NOT_SUPPORTED'
};

export const defaultLoginConfig = {
  title: 'Login to ask more doubts for free',
  bulletPoints: [
    'Upload an image of your doubt and find instant solutions ',
    'Solutions are provided by top educators'
  ],
  image: 'doubts20/loginTouchPoint.svg'
};

/**
 * As per the discussion with CLX team, for the doubts, we can provide state to be
 * constantly 60. Incase this changes going ahead, we will have to call `latest_details` endpoint
 * to fetch the states, for the solution that is currently being paid.
 */
export const VIDEO_RECORDING_STATE = 60;
